module.exports = __webpack_public_path__ + "img/down.e74c1780.png";